module.exports = __webpack_public_path__ + "img/replayCorrect.e2423570.svg";